import { NgModule } from '@angular/core';
import { HasPermissionDirective } from './has-permission-directive';

@NgModule({
  imports: [],
  declarations: [HasPermissionDirective],
  exports: [HasPermissionDirective]
})
export class HasPermissionDirectiveModule {}
